import { useEffect, useState, type JSX, type ReactNode } from 'react';
import { SplashScreen } from '@/components/ui';
import styles from './AppWithSplash.module.css';

const SPLASH_DURATION = 1000;

const AppWithSplash = ({ children }: { children: ReactNode }): JSX.Element => {
  const [showSplash, setShowSplash] = useState(
    () => !sessionStorage.getItem('splashShown')
  );

  useEffect(() => {
    if (showSplash) {
      sessionStorage.setItem('splashShown', 'true');
      const timer = setTimeout(() => setShowSplash(false), SPLASH_DURATION);
      return () => clearTimeout(timer);
    }
    return;
  }, [showSplash]);

  return (
    <>
      {children}
      {showSplash && (
        <div className={styles.splashAppContainer}>
          <SplashScreen />
        </div>
      )}
    </>
  );
};

export default AppWithSplash;
